import React, { Component } from 'react';
import { Grid, Row, Col, Table, Button } from 'react-bootstrap';
import  TrRow  from './TrRow'

class TableResults extends Component {


	render() {
		//var rows = 'ciao';
		var rows = this.props.results.map((result)=>{ return <TrRow key={result.id} date={result.date} user={result.user} userId={result.user_id} followed={result.followed} text={result.text} day={result.day} nextDay={result.next_day} nextWeek={result.next_week} /> });
		//var rows = <TrRow />;
		var pagination = null;
		if(this.props.totalResults > this.props.results.length){
			pagination = <Button block onClick={this.props.anotherPage.bind(this)}>Prosegui</Button>
		}
		return (
			<div>
			<Grid>
				<Row>
					<Col>
						Risultati totali: {this.props.totalResults}
					</Col>
				</Row>
			</Grid>
			 <Table striped bordered condensed responsive>
				<thead>
				  <tr>
					<th>Data</th>
					<th>User</th>
					<th>Testo</th>
					<th>Giorno</th>
					<th>Successivo</th>
					<th>Settimana</th>
				  </tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</Table>
			{pagination}
			</div>
		);
	}
}


export default TableResults;



// WEBPACK FOOTER //
// ./src/components/TableResults.js